function initialValues({ referral, partnerLocation }) {
  const defaultAddress =
    referral?.account?.accountAddresses &&
    referral.account.accountAddresses.length > 0
      ? referral.account.accountAddresses.find(
          (address) => address.isDefault && address.isShipping,
        )
      : null;

  function filterPatient(patient) {
    const { __typename, dob, includeEot, ...rest } = patient;
    return rest;
  }

  function filterUser(user) {
    const { __typename, id, state, ...rest } = user;
    return rest;
  }

  const disclosureItems = referral?.subscriptionDisclosure?.items || [];

  return {
    id: referral?.id || null,
    consentSelectAll: false,
    subscriptionAcknowledgments: disclosureItems.map((item) => ({
      key: item.key,
      agreed: false,
      selectedSubscriptionProductId: null,
      lowerTiersExpanded: false,
    })),
    partnerLocationId: partnerLocation?.id || null,
    userAttributes: referral?.userAttributes
      ? filterUser(referral.userAttributes)
      : {
          firstName: null,
          lastName: null,
          phone: null,
          email: null,
          password: null,
          acceptTerms: false,
          acceptSms: false,
          acceptMarketing: false,
        },
    accountAddressesAttributes: [
      {
        address: defaultAddress?.address || null,
        address2: defaultAddress?.address2 || null,
        city: defaultAddress?.city || null,
        region: defaultAddress?.region || null,
        postalCode: defaultAddress?.postalCode || null,
        country: defaultAddress?.country || 'US',
        isShipping: true,
        isDefault: true,
      },
    ],
    creditCard: {
      nameOnCard: null,
      cardNumber: null,
      expirationDate: null,
      cvv: null,
    },
    billingAddress: {
      address: null,
      address2: null,
      city: null,
      region: null,
      postalCode: null,
      country: 'US',
    },
    patientAttributes: referral?.patientAttributes
      ? filterPatient(referral.patientAttributes)
      : {
          firstName: null,
          lastName: null,
          birthDay: null,
          birthMonth: null,
          birthYear: null,
        },
  };
}

export default initialValues;
